export default "__VITE_ASSET__DDdBJ7ZF__"